export const BaseUrl = 'https://api.tethermine.io/';
export const Version = "1.0"
export const SerialNo = "6ad83fe9f02b32b3"
export const Imei = "6ad83fe9f02b32b3"
export const Appid = "ROUNDPAYAPPID13APR20191351"
export const LoginTypeID = 1
export const socketUrl = 'wss://socket.letskonnect.io:3333/socket'
// export const socketApi = 'http://localhost:3333/'
export const socketApi = 'https://socket.letskonnect.io/'
export const bscRPC = 'https://bsc-mainnet.infura.io/v3/d19158e4ddf74226a8255302e1f7a60b'
export const bscRPCBalance = 'https://site1.moralis-nodes.com/bsc/b160608e80e0485986af3a27a6c47db3'
